// extracted by mini-css-extract-plugin
module.exports = {"root":"root_1_piZ","container":"container_33JXc","headLine":"headLine_1q5Ro","subHeadLine":"subHeadLine_1IoN7","text":"text_2JYSU"};